import { useState } from "react";

export function useBottomShadow(scrollBoxRef: any) {
  const [reachBottom, setReachBottom] = useState(false);

  function initReachBottom() {
    console.log("scrollBoxRef.current", scrollBoxRef.current);
    if (!scrollBoxRef.current) {
      return;
    }
    const { scrollHeight, clientHeight } = scrollBoxRef.current;
    setReachBottom(scrollHeight === clientHeight);
  }

  function handleScrollBottom(event: any) {
    const scrollBox = event.target;
    setReachBottom(
      scrollBox.scrollTop + scrollBox.clientHeight === scrollBox.scrollHeight
    );
  }

  return {
    handleScrollBottom,
    initReachBottom,
    reachBottom,
  };
}
